import { ArrowRightOutlined } from '@ant-design/icons'
import type React from 'react'
import styled from 'styled-components'

import { cardBorder } from 'assets/styles/variables'

type JumpCardVariant = 'filled' | 'outlined'

const Card = styled.button<{ $variant: JumpCardVariant }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 77px;
  padding: 15px 20px;
  border-radius: 16px;
  cursor: pointer;
  text-align: left;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  ${({ $variant }) =>
    $variant === 'filled'
      ? `
    background: #edf1f680;
    border: none;

    &:hover {
      background: #edf1f6;
    }
  `
      : `
    background: #ffffff;
    border: 1px solid ${cardBorder};

    &:hover {
      background: #fafbfc;
      border-color: #c5cad1;
    }
  `}
`

const Left = styled.span`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`

const TitleRow = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  font-size: 18px;
  color: #868d98;
`

const Title = styled.span`
  font-family: var(--Font-family-font-family-body), sans-serif;
  font-size: var(--Font-size-text-sm, 14px);
  line-height: 1;
  font-weight: 600;
  color: #28364f;
`

const Subtitle = styled.span`
  font-family: var(--Font-family-font-family-body), sans-serif;
  font-size: var(--Font-size-text-sm, 14px);
  line-height: 1;
  font-weight: 500;
  color: #868d98;
`

const Cta = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 6px;
  flex-shrink: 0;
  font-family: var(--Font-family-font-family-body), sans-serif;
  font-size: var(--Font-size-text-sm, 14px);
  line-height: var(--Line-height-text-sm, 20px);
  font-weight: 600;
  color: #45689b;
`

export interface JumpCardProps {
  icon: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
  ctaLabel: React.ReactNode
  onClick: () => void
  variant?: JumpCardVariant
  dataChameleon?: string
}

export const JumpCard: React.FC<JumpCardProps> = ({
  icon,
  title,
  subtitle,
  ctaLabel,
  onClick,
  variant = 'filled',
  dataChameleon,
}) => (
  <Card
    type="button"
    onClick={onClick}
    $variant={variant}
    data-chameleon={dataChameleon}
  >
    <Left>
      <TitleRow>
        <IconSlot aria-hidden>{icon}</IconSlot>
        <Title>{title}</Title>
      </TitleRow>
      <Subtitle>{subtitle}</Subtitle>
    </Left>
    <Cta>
      {ctaLabel} <ArrowRightOutlined />
    </Cta>
  </Card>
)
